/**
 * Browser-safe test for environment variables
 */

import { ENV, validateEnvironment, logConfiguration } from '../config/env';

export function browserEnvironmentTest() {
  console.log('=== Browser Environment Test ===');
  
  // Test 1: Check if ENV object is populated
  console.log('1. ENV object:');
  console.log('   ACCESS_KEY:', ENV.ACCESS_KEY ? `***${ENV.ACCESS_KEY.slice(-4)}` : 'NOT SET');
  console.log('   ACTION_KEY:', ENV.ACTION_KEY ? `***${ENV.ACTION_KEY.slice(-4)}` : 'NOT SET');
  console.log('   USE_PROXY:', ENV.USE_PROXY);
  console.log('   USE_MOCK_DATA:', ENV.USE_MOCK_DATA);
  console.log('   NODE_ENV:', ENV.NODE_ENV);
  
  // Test 2: Validate configuration
  console.log('\n2. Validation:');
  const isValid = validateEnvironment();
  console.log('   Configuration valid:', isValid);
  
  // Test 3: Log full configuration
  console.log('\n3. Full Configuration:');
  logConfiguration();
  
  // Test 4: Return summary
  const summary = {
    hasAccessKey: !!ENV.ACCESS_KEY,
    hasActionKey: !!ENV.ACTION_KEY,
    isProxyEnabled: ENV.USE_PROXY,
    isMockDataEnabled: ENV.USE_MOCK_DATA,
    environment: ENV.NODE_ENV,
    isConfigValid: isValid
  };
  
  console.log('\n4. Summary:', summary);
  console.log('=== End Test ===');
  
  return summary;
}

// Make available globally
if (typeof window !== 'undefined') {
  (window as any).browserEnvironmentTest = browserEnvironmentTest;
}